/**
 * Directive: navFocus
 */
angular.module('acme.common.directive.navFocus', [])
.directive('navFocus', ['$timeout', function($timeout) {

    return {
      restrict: 'A',
      scope: {
        showNavFocus: '=navFocus'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs

        function init() {
          bindEvent();
        }

        function bindEvent() {
          $element.bind('click', function(event) {
            $timeout(function(){
              var firstChild = $element.parent().children().find('li a')[0];

              if (firstChild) {
                firstChild.focus();
              }
            }, 10);
          });
        }

        init();
      },

      controller: ['$scope', function($scope) {

        $scope.navFocus = '';

      }]

    };

}]);

